<script lang="ts">
  import { roundOf } from "../../helpers/priceCalculator";
  import type { Product, CostCalculation } from "../../helpers/types";
  import Text from "../atoms/Text.svelte";

  interface Props {
    product: Product;
  }

  let { product }: Props = $props();

  const calculatePrice = (kwh, costs: CostCalculation): number => {
    let comparePrice = 0;
    comparePrice += kwh * ((costs?.discount?.kwhCost ?? costs.kwhCost) * 100);
    comparePrice += 12 * ((costs?.discount?.fixedCost ?? costs.fixedCost) * 100);
    comparePrice /= kwh;

    return roundOf(comparePrice * (costs.vat / 100 + 1), 100);
  };
</script>

<div class="text-Neutral900 text-S">
  <Text variant="primary">2000 kWh: {calculatePrice(2000, product.costs)} öre/kWh</Text>
  <Text variant="primary">5000 kWh: {calculatePrice(5000, product.costs)} öre/kWh</Text>
  <Text variant="primary">20000 kWh: {calculatePrice(20000, product.costs)} öre/kWh</Text>
</div>
